import { render, staticRenderFns } from "./QuanLyMerchantList.vue?vue&type=template&id=4c5a77db&"
import script from "./QuanLyMerchantList.vue?vue&type=script&lang=js&"
export * from "./QuanLyMerchantList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports